// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__3TMDc","sendOtp":"AuthorizeToLogin_sendOtp__wrnkO"};